import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Route, Routes } from 'react-router-dom';
import UpdateSQLPage from './updatesql/updateSQLPage';

export default function IndexPage(props) {


    const classes = useStyles(); 

    return (
        <div className={classes.dashboard} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/bgr-logo.svg), linear-gradient(#EFEFEF,#FFFFFF)`, backgroundRepeat: "no-repeat", backgroundPosition: 'right bottom', backgroundSize: '40%,100%', position: "absolute", width: "100%", zIndex: "0" ,textAlign:"center"}}>
            <div>
                <Routes>
                    <Route
                        path="/"
                        element={
                       
                                <UpdateSQLPage {...props} />
                        }
                    />                                             
                </Routes>
            </div>
            <div className={classes.powered}>Powered by Flagstone</div>
        </div>
    )
}


const useStyles = makeStyles({
    dashboard: {
        display: "inline-block",
        width: "100%",
        height:"100%"
    },
    powered: {
        height: "20px",
        width: "150px",
        position: "absolute",
        bottom: "70px",
        right: "40px",
        overflow: "hidden",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#E8E8E8",
        zIndex: "-1"
      }
});